import axios from './interceptor';

const LOCATION_URL = `${process.env.REACT_APP_BASE_URL}/location`;

export async function getAllLocations(params = {}) {
    const result = await axios.get(LOCATION_URL, { params });
    return result.data;
}

export async function getLocationById(id) {
    const result = await axios.get(`${LOCATION_URL}/${id}`);
    return result.data;
}

export async function createLocation(payload) {
    const result = await axios.post(`${LOCATION_URL}/create`, payload);
    return result.data;
}

export async function updateLocation(id, payload) {
    const result = await axios.put(`${LOCATION_URL}/update/${id}`, payload);
    return result.data;
}

export async function deleteLocation(id) {
    const result = await axios.delete(`${LOCATION_URL}/delete/${id}`);
    return result.data;
}
